export default __webpack_public_path__ + "static/media/Director's Certificate to Ms Nelsa C Arrojado (Cebu branch).526b442d.pdf";